import { render, staticRenderFns } from "./RequestPasswordSend.vue?vue&type=template&id=51988376"
import script from "./RequestPasswordSend.vue?vue&type=script&lang=js"
export * from "./RequestPasswordSend.vue?vue&type=script&lang=js"
import style0 from "./RequestPasswordSend.vue?vue&type=style&index=0&id=51988376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports